const PrevHandler = {
  init(page, btnPrevSurah) {
    this._prevPage(page, btnPrevSurah);
    this._onFirstPage(page, btnPrevSurah);
  },

  _prevPage(page, btnPrevSurah) {
    btnPrevSurah.addEventListener('click', () => {
      location.assign(`#/surah/${Number(page) - 1}`);
    });
  },

  _onFirstPage(page, btnPrevSurah) {
    if (page === '1') {
      btnPrevSurah.setAttribute('disabled', '');
      btnPrevSurah.firstElementChild.classList.add('hidden');
    }
  },
};

export default PrevHandler;
